export default "__VITE_ASSET__BENM5Km$__"